import React, { useState } from "react";
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import Loadable from "react-loadable";

import { appNavigationInfo } from "../../redux/reducers/appNavigation";
import Carousel from '../../components/Carousel/Carousel';
import "./BookingPage.scss";
import { changePage } from "../../redux/actions";
import DatePicker, { registerLocale } from "react-datepicker";
import ajaxSettingsConstructor from "../../helpers/ajaxSettingsConstructor";
import "react-datepicker/dist/react-datepicker.css";
import * as $ from 'jquery';
import { zhTW } from "date-fns/locale";
import hostname from "../../configs/hostName";


const HorizontalScrollList = Loadable({
    loader: () => import("../../components/HorizontalScrollList/HorizontalScrollListContainer"),
    loading: () => null,
    modules: ["HorizontalScrollListChunk"],
});
const BookingPage = (props) => {
    let submitted = false;
    const dispatch = useDispatch();

    const pageStatus = useSelector(state => state.appNavigation.currentPage.name === appNavigationInfo.bookingPage.name, shallowEqual);

    const [selectedProduct, setSelectedProduct] = useState(-1);
    const [selectedPromotionProduct, setSelectedPromotionProduct] = useState([]);

    const banners = useSelector(state => state.appData.banners, shallowEqual);
    const services = useSelector(state => state.appData.services, shallowEqual);
    const redeems = useSelector(state => state.appData.redeems, shallowEqual);
    const area = useSelector(state => state.appData.area, shallowEqual);
    const settings = useSelector(state => state.appData.settings, shallowEqual);

    registerLocale('zhTW', zhTW)


    const [startDate, setStartDate] = useState(null);

    const [unuseDate, setUnuseDate] = useState( [new Date()]);
    const [unuseWeek, setUnuseWeek] = useState([]);
    const [useDate, setUseDate] = useState([]);

    const [people, setPeople] = useState(-1);
    const [install, setInstall] = useState(-1);

    const [districtId, setDistrictId] = useState(null);
    const [areaId, setAreaId] = useState(null);

    const [district, setDistrict] = useState([]);
    const [timeap, setTimeap] = useState([]);
    const [timeapSelect, setTimeapSelect] = useState(null);

    const [address, setAddress] = useState(null);
    const [email, setEmail] = useState(null);
    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [remark, setRemark] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [code, setCode] = useState(null);
    const [dateDisable, setDateDisable] = useState(true);
    const [terms, setTerms] = useState(false);

    const [expandedServiceFeature, setExpandedServiceFeature] = useState(0);
    const [expandedServiceContractDetail, setExpandedServiceContractDetail] = useState(0);
    const [expandedRedeemItemFeature, setExpandedRedeemItemFeature] = useState(0);

    const selectProduct = (index) => {
        if (index.id === selectedProduct) {
            setSelectedProduct(-1);
        } else {
            setSelectedProduct(index.id);
        }
    }

    const selectPromotionProduct = (index) => {
        if (selectedPromotionProduct.includes(index.id)) {
            setSelectedPromotionProduct(selectedPromotionProduct.filter(id => id != index.id));
        } else {
            setSelectedPromotionProduct(selectedPromotionProduct.concat(index.id));
        }
    }

    const selectArea = (value) => {
        setAreaId(value.target.value);
        if (value.target.value == -1){
            setDistrict([])
        } else{
            for(let areaItem of area){
                if (areaItem.id == value.target.value) {
                    setDistrict(areaItem.district)
                    return false;
                }
            }
        }

    }
    function getDay(date) {
        var myDate = new Date(date);
        return myDate.getDay()
    }

    const isWeekday = date => {
        const day = getDay(date);
        return unuseWeek.indexOf(day) === -1;
    };

    const selectDistrict = (value) => {
        setDistrictId(value.target.value);
       if (value.target.value !== -1){
           const ajaxSettings = ajaxSettingsConstructor(
               `${hostname}/api/unuseData`,
               "GET",
               {id:value.target.value},
           );

           $.ajax(ajaxSettings)
               .then(data => {
                   if (data.meta.code === 'RESP_OKAY') {
                       setUnuseDate(data.data.unuse);
                       setUnuseWeek(data.data.unuseWeek);
                       setUseDate(data.data.usedate);
                       setDateDisable(false)
                   } else {
                       console.error('fetch Area list data error', data)
                   }
               })
               .fail(() => {
                   console.log("fail to get server update time");
               })
               .catch(error => console.log(error));
       }else{
           setDateDisable(true)
           setStartDate(null)
           setTimeap([])
       }

    }

    const addMonths = (v, n)=> {
        if (v) {
            var t = new Date(v.getFullYear(), v.getMonth(), v.getDate(), v.getHours(), v.getMinutes(), v.getSeconds(), v.getMilliseconds());
            t.setMonth(v.getMonth() + n);
            if (t.getDate() !== v.getDate()) { t.setDate(0); }
            return t;
        }
    }

    const dateSelect = (date)=>{
        const dateFromat = getfromatDate('YYYY-mm-dd',date);
        let timeapItem = [];
        let useDateItem = useDate[dateFromat];

        if (useDateItem) {
            if (useDateItem.am > 0){
                timeapItem.push({
                    'title':'上午 0930 - 1200',
                    'value':'am',
                })
            }

            if (useDateItem.pm > 0){
                timeapItem.push({
                    'title':'下午 1300 - 1730',
                    'value':'pm',
                })
            }
        }else{
            timeapItem.push({
                'title':'上午 0930 - 1200',
                'value':'am',
            })
            timeapItem.push({
                'title':'下午 1300 - 1730',
                'value':'pm',
            })
        }
        setStartDate(date)
        setTimeap(timeapItem)
    }

    function getfromatDate(fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    }

    function isEmpty(obj){
        if(typeof obj === "undefined" || obj === null || obj === "" || obj === -1){
            return true;
        }else{
            return false;
        }
    }

    function submit() {
        if (submitted === true) return;
        submitted = true;
        if (isEmpty(selectedProduct)) {
            alert('請選擇產品')
        }else if (isEmpty(areaId)) {
            alert('請選擇地區')
        }
        else if (isEmpty(districtId)) {
            alert('請選擇分區')
        }
        else if (isEmpty(startDate)) {
            alert('請選擇日期')
        }
        else if (isEmpty(timeapSelect)) {
            alert('請選擇時間')
        }
        else if (isEmpty(address)) {
            alert('請輸入安裝地址')
        }
        else if (isEmpty(name)) {
            alert('請輸入姓名')
        }
        else if (isEmpty(email)) {
            alert('請輸入電郵地址')
        }
        else if (isEmpty(phone)) {
            alert('請輸入聯絡電話')
        }else{
            let sendData = {
                'email':email,
                'address':address,
                'name':name,
                'phone':phone,
                'remark':remark,
                'code':code,
                'discount':discount,
                'service_id':selectedProduct,
                'redeem_id':selectedPromotionProduct,
                'district_id':districtId,
                'area_id':areaId,
                'time':timeapSelect,
                'date':getfromatDate('YYYY-mm-dd',startDate),
            }

            sendData = JSON.stringify(sendData);

            const ajaxSettings = ajaxSettingsConstructor(
                `${hostname}/api/order`,
                "POST",
                sendData,
            );

            $.ajax(ajaxSettings)
                .then(data => {
                    if (data && data.meta && data.meta.code && data.meta.code === 'RESP_OKAY' &&
                        data.data && data.data.stripe_key && data.data.checkout_session_id) {
                        var stripe = window.Stripe(data.data.stripe_key);
                        stripe.redirectToCheckout({
                            sessionId: data.data.checkout_session_id
                        }).then(function (result) {
                            alert('重新導向付款網站時發生錯誤，請稍後再試');
                        });
                    } else {
                        alert('提交時發生未知錯誤，請重新提交！')
                    }
                })
                .fail((data) => {
                    console.log(data);
                    submitted = false;
                })
                .catch(data => {
                    data = data.responseJSON;
                    if (data && data.meta && data.meta.code && data.meta.code === 'GENL_0001') {
                        alert(data.data.error ? data.data.error : data.meta.message);
                    } else if (data && data.meta && data.meta.code && data.meta.code === 'STRIP_0001') {
                        alert("付款網關錯誤，請稍候再試");
                    } else {
                        alert('提交時發生未知錯誤，請重新提交！')
                    }
                    submitted = false;
                });
        }
    }

    const toggleServiceFeature = (service) => {
        setExpandedServiceFeature(service.id === expandedServiceFeature ? 0 : service.id);
    }

    const toggleServiceContractDetail = (service) => {
        setExpandedServiceContractDetail(service.id === expandedServiceContractDetail ? 0 : service.id);
    }

    const toggleRedeemItemFeature = (redeem_item) => {
        setExpandedRedeemItemFeature(redeem_item.id === expandedRedeemItemFeature ? 0 : redeem_item.id);
    }

    const renderSelectedService = () => {
        if (!selectedProduct || selectedProduct === -1) return null;

        const selectedService = services.find(service => service.id === selectedProduct);
        return (<>
            <div className="title confirmation-title">訂單確認</div>
            <div className="order-confirmation">
                <table>
                    <thead>
                        <tr>
                            <th className="col1">產品</th>
                            <th className="col2">價格</th>
                            <th className="col3">小計</th>
                        </tr>
                    </thead>
                    <tbody>
                        { selectedService &&
                            <>
                                <tr>
                                    <td className="item-col1">
                                        <div className="item">
                                            <img src={ selectedService.image }/>
                                            <div className="text">
                                                <div>{ selectedService.title }</div>
                                                <div>{ selectedService.sub_title }</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="item-col2">
                                        <div className="item">
                                            <div className="text">
                                                <div>月費 ${selectedService.monthly_fee}</div>
                                                {selectedService.contract_period !== 0 && <div>合約期 {selectedService.contract_period} 個月</div>}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="item-col3">
                                        <div className="item">
                                            <div className="text">
                                                <div>HK${selectedService.monthly_fee}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        }
                        { redeems &&
                        redeems.length > 0 &&
                        redeems
                        .filter((r) => selectedPromotionProduct.includes(r.id))
                        .map((promotionProduct, i) => (
                            <tr key={'promotion_product_' + i}>
                                <td className="item-col1">
                                    <div className="item">
                                        <img src={ promotionProduct.image }/>
                                        <div className="text">
                                            <div>{ promotionProduct.title }</div>
                                            <div>{ promotionProduct.sub_title }</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="item-col2">
                                    <div className="item">
                                        <div className="text">
                                            <div>換購價 ${ promotionProduct.price }</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="item-col3">
                                    <div className="item">
                                        <div className="text">
                                            <div>HK${ promotionProduct.price }</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>)
    }

    return (
        <div className={`BookingPage page ${pageStatus ? 'active' : ''}`} id={'BookingPage'}>
            <div className="carousel-container">
                <Carousel id={"searchpage-list-landscape-carousel"} animation="slide" autoPlay={true} isShowIndicators={true} >
                    {banners.map((banner, i)=>{
                        return <a key={'banner_' + i} href={banner.url === null ? "#" : banner.url} target={banner.url === null ? "" : "_blank"}><img alt="" src={banner.path} className='banner' key={"banner-" + banner.id} /></a>
                    })
                }
                 {/* <img alt="" src={require("../../assets/images/bookingpage/banner.png")} className='banner' />
                 <img alt="" src={require("../../assets/images/bookingpage/banner2.jpg")} className='banner' /> */}
                </Carousel>
            </div>

            <div className="selection-container">
                 <div className="selection-label">
                    <div className="selection-label-number">1</div>
                    <div className="selection-label-text">提供選購資訊</div>
                 </div>

                 <div className="fill"></div>

                <select className="select" name="selection1" id="selection1" onChange={value=>setPeople(value.target.value)}>
                    <option value={-1}>請選擇家庭用水人數</option>
                    <option value={1}>1-3人</option>
                    <option value={2}>3-5人</option>
                    <option value={3}>5人以上</option>
                </select>

                <select className="select" name="selection2" id="selection2" onChange={value=>setInstall(value.target.value)}>
                    <option value={-1}>請選擇安裝方式</option>
                    <option value={1}>座枱/掛牆（不需鑚孔）</option>
                    <option value={2}>枱底安裝</option>
                    <option value={3}>直飲水機</option>
                </select>
            </div>

            <div className="title-2">
                <div className="selection-label">
                    <div className="selection-label-number">2</div>
                    <div className="selection-label-text">建議精選組合</div>
                 </div>
            </div>

            {/* <div className="title">服務選擇</div> */}

            <HorizontalScrollList id="product-list">
                {
                    services.map((i, index) => {
                        let peopleArray = i.people.map(Number);
                        if ( (parseInt(people) === -1 || peopleArray.indexOf(parseInt(people)) > -1) && (parseInt(install) === -1 || i.install === parseInt(install))) {
                            return <div key={"test-" + index} className={`list-item ${selectedProduct === i.id ? 'item-selected' : ''}`} >
                                <img className="plan-image" alt="" src={i.image} />
                                <div className="plan-title">{i.title}</div>
                                <div className="plan-detail">{i.sub_title}</div>
                                {i.feature &&
                                    <div>
                                        <div className={expandedServiceFeature === i.id ? "plan-feature expanded" : "plan-feature"} onClick={() => toggleServiceFeature(i)}>產品特點</div>
                                        <div className={expandedServiceFeature !== i.id ? "plan-feature-detail collapsed" : "plan-feature-detail"} onClick={() => toggleServiceFeature(i)}>{i.feature}</div>
                                    </div>
                                }
                                <div className="plan-bottom">
                                    <div className="payment">
                                        <div>月費 $ {i.monthly_fee}</div>
                                        {i.contract_period !== 0 && <div>
                                            合約期 {i.contract_period} 個月
                                        </div>}
                                    </div>
                                    <div className={`select-button ${selectedProduct === i.id ? 'selected' : ''}`} onClick={() => { selectProduct(i) }}>{selectedProduct === i.id ? '已選擇' : '選擇'}</div>
                                </div>
                                {i.contract_details && <div className="contract-container">
                                    <div className={expandedServiceContractDetail === i.id ? "contract expanded" : "contract"} onClick={() => toggleServiceContractDetail(i)}>
                                        合約詳細內容
                                    </div>
                                    <div className={expandedServiceContractDetail !== i.id ? "contract-detail collapsed" : "contract-detail"} onClick={() => toggleServiceContractDetail(i)}>{i.contract_details}</div>
                                </div>}
                            </div>
                        }

                    })
                }
            </HorizontalScrollList>
            {/* <div className="exchange-title">申請以上任何一個服務可以優惠價換購以下產品</div> */}
            <div className="title-3-wrapper">
                <div className="title-3">
                    <div className="selection-label">
                        <div className="selection-label-number">3</div>
                        <div className="selection-label-text">加購優惠產品</div>
                    </div>
                </div>
                <div className="title-3-description">申請以上任何一個服務可以優惠價換購以下產品</div>
            </div>
            <HorizontalScrollList id="promotion-product-list">
                {
                    redeems.map((i, index) => {

                        return <div key={'test-0' + index} className="list-item" >
                            <img className="plan-image" alt="" src={i.image} />
                            <div className="plan-title">{i.title}</div>
                            <div className="plan-detail">{i.sub_title}</div>
                            {i.feature &&
                            <div>
                                <div className={expandedRedeemItemFeature === i.id ? "plan-feature expanded" : "plan-feature"} onClick={() => toggleRedeemItemFeature(i)}>產品特點</div>
                                <div className={expandedRedeemItemFeature !== i.id ? "plan-feature-detail collapsed" : "plan-feature-detail"} onClick={() => toggleRedeemItemFeature(i)}>{i.feature}</div>
                            </div>
                            }
                            <div className="plan-bottom">
                                <div className="payment">
                                    {i.original_price  && <div className="original_price">原價：$ <span className="crossed">{i.original_price}</span></div>}
                                    <div>換購價：$ {i.price}</div>

                                </div>
                                <div className={`select-button ${selectedPromotionProduct.includes(i.id) ? 'selected' : ''}`} onClick={() => { selectPromotionProduct(i) }}>{selectedPromotionProduct.includes(i.id) ? '已選擇' : '選擇'}</div>
                            </div>
                        </div>
                    })
                }
            </HorizontalScrollList>

            {renderSelectedService()}

            <div className="address-container">
                <div className="title">立即查詢安裝地區</div>
                <div className="dist-container">
                    {/* <div className="hint">請選擇地區 ： </div> */}
                    <div className="selection-container">
                        <div className="fill"></div>
                        <select className="select" name="selection1" id="selection1" onChange={value=>selectArea(value)}>
                            <option value="-1">請選擇地區</option>
                            {area.map(areaItem=>{
                                return <option key={'area-0'+areaItem.id} value={areaItem.id}>{areaItem.name}</option>
                            })
                            }
                        </select>

                        <select className="select" name="selection2" id="selection2" onChange={value=>selectDistrict(value)} >
                            <option value="-1">請選擇分區</option>
                            {district.map(districtItem=>{
                                return <option key={'area-0'+districtItem.id} value={districtItem.id}>{districtItem.name}</option>
                            })
                            }
                        </select>
                        <div className="fill"></div>
                    </div>
                </div>

                <div className="selection-container">
                    <div className="fill"></div>
                    <DatePicker
                        className="date-select"
                        selected={startDate}
                        onChange={date => dateSelect(date)}
                        dateFormat="yyyy-MM-dd"
                        excludeDates={unuseDate}
                        minDate={new Date()}
                        maxDate={addMonths(new Date(),2)}
                        filterDate={isWeekday}
                        placeholderText="請選擇理想日子"
                        locale="zhTW"
                        calendarClassName="booking-calendar"
                        disabled={dateDisable}
                    />

                    <select className="select" name="selection-time" id="selection-time" onChange={value => setTimeapSelect(value.target.value)}>
                        <option value="-1">請選擇理想時間</option>
                        {timeap.map((timeapItem,index)=>{
                            return    <option key={"test-" + index} value={timeapItem.value}>{timeapItem.title}</option>
                        })
                        }
                    </select>
                    <div className="fill"></div>
                </div>

                <div>
                    *所選日子及時間將有客服專員通知確認作實
                </div>
            </div>


            <div className="title-4">
                <div className="selection-label">
                    <div className="selection-label-number">4</div>
                    <div className="selection-label-text">填寫資料</div>
                </div>
            </div>

            <div className="form-container">
                <div className="input-container" style={{ marginLeft: 0, minWidth: '100%', display: 'block' }}>
                    <div className="input-title">安装地址 <span className="span-red">*</span></div>
                    <input className="input" onChange={value=>setAddress(value.target.value)}  />
                </div>
                <div className="input-container" style={{ marginLeft: 0 }}>
                    <div className="input-title">電子郵件 <span className="span-red">*</span></div>
                    <input type="email" className="input" onChange={value=>setEmail(value.target.value)} />
                </div>
                <div className="input-container">
                    <div className="input-title">中文或英文姓名 <span className="span-red">*</span></div>
                    <input className="input" onChange={value=>setName(value.target.value)}  />

                </div>
                <div className="input-container" style={{ marginLeft: 0 }}>
                    <div className="input-title">聯絡電話 <span className="span-red">*</span></div>
                    <input className="input" onChange={value=>setPhone(value.target.value)}  />

                </div>
                <div className="input-container" >
                    <div className="input-title">客戶備註</div>
                    <input className="input" onChange={value=>setRemark(value.target.value)} />
                </div>
                <div className="input-container" style={{ marginLeft: 0 }}>
                    <div className="input-title">推薦人編號</div>
                    <input className="input"  onChange={value=>setCode(value.target.value)}/>
                </div>
                <div className="input-container" >
                    <div className="input-title">優惠代碼</div>
                    <input className="input" onChange={value=>setDiscount(value.target.value)}/>
                </div>
                <div className="input-container" style={{ marginLeft: 0, minWidth: '100%' }}>
                    <div className="input-title">服務條款</div>
                    <div className="terms" key="tnc">{settings.tnc}</div>
                </div>
                <div className="accept-checkbox">
                    <input type="checkbox" id="accept" name="accept" value="accept" onChange={value=>{setTerms(!terms)}} />
                    <label >本人明白及接受以上條款</label>
                </div>

                <div className="submit-button"
                    // onClick={() => {
                    //     console.log("submit", appNavigationInfo.orderInfoPage);
                    //     dispatch(changePage(appNavigationInfo.orderInfoPage));
                    // }}>提交</div>
                onClick={()=>{
                    if (terms) {
                        submit()
                    }else{
                        alert('請同意條款後在進行操作');
                    }

                }}>提交</div>
            </div>
        </div>
    )
}

export default BookingPage;
